// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen {
  .printOnly {
    display: none;
  }
}

@media print {
  body {
    margin: 0mm !important;
    -webkit-print-color-adjust: exact;
  }

  .printOnly,
  .printOnly * {
    visibility: visible;
    display: initial;
  }

  .printOnly.printRemove {
    display: none;
  }

  .printSection,
  .printSection * {
    visibility: visible;
  }

  .printRemove,
  .printRemove * {
    display: none;
  }

  .printHide,
  .printHide * {
    visibility: hidden;
  }

  .printHide .printSection * {
    visibility: visible;
  }

  .printRemove .printSection * {
    visibility: visible;
  }

  .avoidPageBreak {
    page-break-inside: avoid;
  }

  td div {
    page-break-inside: avoid;
  }

  thead {
    display: table-header-group;
  }

  .noPrintMargin {
    margin: 0px !important;
    padding: 0px !important;
  }

  @page {
    margin: 0cm;
  }

  @page :first {
    margin-top: 0cm;
  }

  @page :left {
    margin-left: 0cm;
    margin-right: 0cm;
  }

  @page :right {
    margin-left: 0cm;
    margin-right: 0cm;
  }
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/angularPrint.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;;IAEE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":["@media screen {\n  .printOnly {\n    display: none;\n  }\n}\n\n@media print {\n  body {\n    margin: 0mm !important;\n    -webkit-print-color-adjust: exact;\n  }\n\n  .printOnly,\n  .printOnly * {\n    visibility: visible;\n    display: initial;\n  }\n\n  .printOnly.printRemove {\n    display: none;\n  }\n\n  .printSection,\n  .printSection * {\n    visibility: visible;\n  }\n\n  .printRemove,\n  .printRemove * {\n    display: none;\n  }\n\n  .printHide,\n  .printHide * {\n    visibility: hidden;\n  }\n\n  .printHide .printSection * {\n    visibility: visible;\n  }\n\n  .printRemove .printSection * {\n    visibility: visible;\n  }\n\n  .avoidPageBreak {\n    page-break-inside: avoid;\n  }\n\n  td div {\n    page-break-inside: avoid;\n  }\n\n  thead {\n    display: table-header-group;\n  }\n\n  .noPrintMargin {\n    margin: 0px !important;\n    padding: 0px !important;\n  }\n\n  @page {\n    margin: 0cm;\n  }\n\n  @page :first {\n    margin-top: 0cm;\n  }\n\n  @page :left {\n    margin-left: 0cm;\n    margin-right: 0cm;\n  }\n\n  @page :right {\n    margin-left: 0cm;\n    margin-right: 0cm;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
